/**
 * Sentry Error Logging
 */
import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";

Sentry.init({
  dsn: "https://bcbacc53f4994f13ac0960d004280f1a@o662291.ingest.sentry.io/5765291",
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0,
});
